import { Component, EventEmitter, Input, Output } from '@angular/core';
import { map, timer, takeWhile } from 'rxjs';

@Component({
  selector: 'count-down',
  templateUrl: './count-down.component.html'
})
export class CountDownComponent {
  display: any = "00:00";
  @Output() reSendTimer = new EventEmitter<boolean>();

  constructor() {
    this.timer(2);
  }

  timer(minute: any) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;

    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        clearInterval(timer);
        this.reSendTimer.emit(true);
      }else{
        this.reSendTimer.emit(false);
      }
    }, 1000);
  }

}